import {Grid2 as Grid, Typography} from "@mui/material";
import {Button} from "@mui/material";
import ModalDrawer from "./ModalDrawer";

export default function ConfirmModal({ open, onConfirm, onDeny, children, confirmDisabled, loading, confirmText = 'Conferma' , titleText}) {
    const title = titleText
        ? <Typography component="div" variant="subtitle2" className="uppercase">{titleText}</Typography>
        : null;

    return <ModalDrawer open={open}>
        <Grid container spacing={2}>
            {title}
            <Grid size={12}>
                {children}
            </Grid>
            <Grid size={12}>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={onConfirm}
                    disabled={!!confirmDisabled}
                    loading={loading}
                >
                    {confirmText}
                </Button>
            </Grid>
            <Grid size={12}>
                <Button
                    fullWidth
                    color="error"
                    onClick={onDeny}
                    variant="contained"
                    loading={loading}
                >
                    Annulla
                </Button>
            </Grid>
        </Grid>
    </ModalDrawer>
}